module.exports = __webpack_public_path__ + "img/pro-p-slider10.0306ad3b.png";